import SuggestionItem from "./SuggestionItem";
import PropTypes from "prop-types";
import ArrowWhite from "../Shared/icons/ArrowWhite";
import React from "react";

function SuggestionList({items, total, buttonText, onItemClick, onButtonClick, noResultsText}) {
    return (
        <div className="suggest-dropdown suggest-dropdown--active">
            {total > 0
                ? items.map((item) => <SuggestionItem
                    key={item.productId} {...item}
                    onClick={() => onItemClick(item)}
                />)
                : <div className="suggest-dropdown__item">
                    <div className="suggest-dropdown__item-name">
                        <span>{noResultsText}</span>
                    </div>
                </div>
            }
            <button className="btn btn-secondary justify-content-between d-flex" onClick={onButtonClick}>
                <span>{buttonText}</span>
                <ArrowWhite/>
            </button>
        </div>
    );
}

SuggestionList.propTypes = {
    items: PropTypes.array,
    buttonText: PropTypes.string.isRequired,
    onItemClick: PropTypes.func.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    noResultsText: PropTypes.string,
};

export default SuggestionList;